<template>
  <div class="page-content">
    <div class="search-wrap">
      <div class="search-options-wrap">
        <div class="option-item">
          <div class="option-title">{{ $t('public.status') }}</div>
          <a-select
            allowClear
            showSearch
            v-model="academic"
            style="width: 100%"
            :placeholder="$t('public.academicYear')"
            :dropdownMatchSelectWidth="false"
          >
            <a-select-option
              v-for="(item, index) in academicYearList"
              :key="index"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </div>

        <div class="search-wrap--input">
          <a-input-search
            :placeholder="
              $t('public.searchList', {
                content:
                  $t('public.submitter_lower') +
                  '、' +
                  $t('public.student_lower') +
                  ' ' +
                  $t('public.name_lower'),
              })
            "
            enterButton
            class="search-input"
            v-model="searchModel"
            @search="approvalData"
          />
        </div>
      </div>
    </div>

    <a-table
      :data-source="approvalList"
      :rowKey="(approvalList) => approvalList.id"
      :scroll="{ x: 1500 }"
      :loading="loading"
      :pagination="{
        total: total,
        pageSize: pageSize,
        current: current,
        showTotal: (total) =>
          $t('public.page', { total: total, pageSize: pageSize }),
        onChange: currentChange,
      }"
    >
      <a-table-column
        :width="150"
        fixed="left"
        :title="$t('public.subject')"
        dataIndex="courseName"
      >
      </a-table-column>
      <a-table-column
        fixed="left"
        :width="150"
        :title="$t('public.student') + ' ' + $t('public.name_lower')"
        dataIndex="studentName"
      >
      </a-table-column>
      <a-table-column
        :width="150"
        :title="$t('report.academicYear')"
        dataIndex="academic"
      >
      </a-table-column>
      <a-table-column
        :width="150"
        :title="$t('public.semester')"
        dataIndex="semester"
      >
      </a-table-column>
      <!-- <a-table-column
        :width="150"
        :title="$t('public.teacher') + $t('public.name')"
        dataIndex="teacherName"
      >
      </a-table-column> -->
      <a-table-column
        :width="150"
        :title="$t('public.submitter')"
        dataIndex="submitterName"
      >
      </a-table-column>
      <a-table-column
        :width="150"
        :title="$t('public.approver')"
        dataIndex="approverName"
      >
      </a-table-column>
      <a-table-column
        :width="150"
        :title="$t('public.scoreType')"
        dataIndex="type"
      >
        <template slot-scope="type">
          <p>
            {{
              type == 1 ? 'Regular Grade' : type == 2 ? 'Semester Exam' : 'Quiz'
            }}
          </p>
        </template>
      </a-table-column>

      <a-table-column
        :width="150"
        :title="$t('public.details')"
        dataIndex="details"
      >
      </a-table-column>
      <!-- //323 -->
      <a-table-column
        :width="150"
        :title="$t('public.submissionTime')"
        dataIndex="createTime"
      >
      </a-table-column>
      <a-table-column
        :width="150"
        :title="$t('public.approvalTime')"
        dataIndex="updateTime"
      >
      </a-table-column>
      <a-table-column
        :width="150"
        fixed="right"
        :title="$t('public.oldScore')"
        dataIndex="oldScore"
      >
      </a-table-column>
      <a-table-column
        fixed="right"
        :width="150"
        :title="$t('public.newScore')"
        dataIndex="newScore"
      >
      </a-table-column>
    </a-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      academic: undefined,
      searchModel: '',
      selectedRowKeys: [],
      pageSize: 10,
      total: 0,
      current: 1,
      loading: false,
      approvalList: [],
    }
  },
  computed: {
    ...mapGetters(['academicYearList']),
  },
  watch: {
    academic() {
      this.approvalData()
    },
  },
  methods: {
    selectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    currentChange(pageNumber) {
      this.current = pageNumber
      this.approvalData()
    },
    approvalData() {
      this.loading = true
      this.$http(this.$api.SELECTPAGERECORD, {
        academic: this.academic ? this.academic : '',
        userName: this.searchModel,
        pageSize: this.pageSize,
        pageNO: this.current,
      }).then((r) => {
        this.loading = false
        this.total = r.data.total || 0
        this.approvalList = r.data.rows || []
      })
    },
    // 默认学年学期
    selectYearSemester() {
      const nowTime = new Date()
      const year = nowTime.getFullYear()
      const month = nowTime.getMonth() + 1

      if (month > 8) {
        for (const item of this.academicYearList) {
          if (item.indexOf(year) === 0) {
            this.academic = item
          }
        }
      } else {
        for (const item of this.academicYearList) {
          if (item.indexOf(year - 1) === 0) {
            this.academic = item
          }
        }
      }
    },
  },

  created() {
    // this.selectYearSemester()
    this.approvalData()
  },
}
</script>
